import { render } from "./AcceptWindow.vue?vue&type=template&id=0231fc1f"
import script from "./AcceptWindow.vue?vue&type=script&lang=js"
export * from "./AcceptWindow.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__